import { withStyles } from '@material-ui/styles';
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import * as v from '../../../helpers/validation';
import { DynamicForm } from '../../DynamicForm';
// SERVICES
import {
  editUserRestrictions,
  getAgents,
  getClientList,
  getFormHeaders,
  getUserRestrictionsByUserId,
} from '../../../services';

const styles = theme => ({
  logoContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  existingLogo: {
    height: '100%',
    maxHeight: 150,
  },
});

export const RestrictionsEdit = withStyles(styles)(props => {
  const { match } = props;
  const { userId } = match.params;
  const [clientList, setClientList] = useState([]);
  const [formHeaderList, setFormHeaderList] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [userRestrictions, setUserRestrictions] = useState(null);

  useEffect(() => {
    getUserRestrictionsByUserIdAsync();
    getClientListAsync();
    getFormHeaderListAsync();
    getAgentListAsync();
  }, []);

  const getUserRestrictionsByUserIdAsync = async () => {
    const response = await getUserRestrictionsByUserId(userId);
    setUserRestrictions(response);
  };

  const getClientListAsync = async () => {
    let clients = await getClientList();
    clients = clients.map(c => {
      return {
        value: c.id,
        label: `${c.name} ${c.code && `(${c.code})`}`,
      };
    });
    setClientList(clients);
  };

  const getFormHeaderListAsync = async () => {
    let formHeaders = await getFormHeaders();
    formHeaders = formHeaders.map(fh => {
      return {
        value: fh.formHeaderId,
        label: `${fh.name}`,
      };
    });
    setFormHeaderList(formHeaders);
  };

  const getAgentListAsync = async () => {
    let agents = await getAgents();
    agents = agents.map(a => {
      return {
        value: a.id,
        label: `${a.agentName}`,
      };
    });
    setAgentList(agents);
  };

  const restrictionInputs = [
    {
      inputType: 'gridcontainer',
      children: [
        {
          inputType: 'griditem',
          children: [
            {
              inputType: 'select',
              field: 'clientIds',
              label: 'Clients',
              validate: [],
              options: clientList,
              isMulti: true,
            },
            {
              inputType: 'select',
              field: 'formHeaderIds',
              label: 'Form Headers',
              validate: [],
              options: formHeaderList,
              isMulti: true,
            },
            {
              inputType: 'select',
              field: 'agentMasterIds',
              label: 'Agents',
              validate: [],
              options: agentList,
              isMulti: true,
            },
            {
              inputType: 'text',
              field: 'name',
              label: 'Name',
              validate: [],
              disabled: true,
            },
            {
              inputType: 'text',
              field: 'userName',
              label: 'UserName',
              validate: [],
              disabled: true,
            },
            {
              inputType: 'text',
              field: 'email',
              label: 'Email',
              validate: [],
              disabled: true,
            },
            {
              inputType: 'text',
              field: 'roles',
              label: 'Roles',
              validate: [],
              disabled: true,
            },
            {
              inputType: 'text',
              field: 'address',
              label: 'Address',
              validate: [],
              disabled: true,
            },
            {
              inputType: 'text',
              field: 'city',
              label: 'City',
              validate: [],
              disabled: true,
            },
            {
              inputType: 'text',
              field: 'state',
              label: 'State',
              validate: [],
              disabled: true,
            },
            {
              inputType: 'text',
              field: 'zip',
              label: 'Zip',
              validate: [],
              disabled: true,
            },
          ],
        },
      ],
    },
  ];

  return (
    <div className={classnames('grid-container')}>
      <div>
        *User Restrictions are managed by exception. Users will only be restricted from assignment to Clients, Form
        Headers, and Agents that are specified below.
      </div>
      <DynamicForm
        inputs={restrictionInputs}
        data={userRestrictions}
        mode={'EDIT'}
        onSave={editUserRestrictions}
        redirectOnSuccess={'/users/restrictions'}
      />
    </div>
  );
});
